<template>
  <div class="ss-payment-form">
    <div class="ss-field">
      <p class="dim small medium">{{ t('card_info') }}</p>
      <div id="element-card-number" class="ss-card-element"></div>
      <div class="ss-card-element">
        <div id="element-card-expiry"></div>
        <div id="element-card-cvc"></div>
      </div>
    </div>

    <Checkbox v-model="isAgreedTerms">
      <span class="small dim">{{ t('terms_stripe_card_add') }} </span>
    </Checkbox>

    <div class="wrapper-buttons">
      <ButtonProcess full-width secondary @click="props.close()">
        {{ t('label_cancel') }}
      </ButtonProcess>
      <ButtonProcess full-width @click="handleSave" :disabled="!isAgreedTerms || isLoading">
        {{ t('button_save') }}
      </ButtonProcess>
    </div>
  </div>
</template>

<script setup lang="ts">
import ButtonProcess from '@/components/shared/base/ButtonProcess.vue';
import Checkbox from '@/components/shared/base/Checkbox.vue';
import { useStripe } from '@/composables/domains/self-service/useStripe';

const props = withDefaults(
  defineProps<{
    callback: () => void;
    close: () => void;
  }>(),
  {}
);

const { t } = useI18n();

const {
  elementCardNumber,
  elementCardExpiry,
  elementCardCvc,
  initStripeElements,
  handleCardAdd,
  createDomCardNumber,
  createDomCardExpiry,
  createDomCardCvc,
} = useStripe();

const isAgreedTerms = ref(false);
const isLoading = ref(false);

const handleSave = async () => {
  isLoading.value = true;

  const result = await handleCardAdd();
  if (result) {
    props.callback();
    props.close();
  }

  isLoading.value = false;
};

onMounted(async () => {
  await initStripeElements();
  await createDomCardNumber();
  await createDomCardExpiry();
  await createDomCardCvc();

  elementCardNumber.value!.mount('#element-card-number');
  elementCardExpiry.value!.mount('#element-card-expiry');
  elementCardCvc.value!.mount('#element-card-cvc');
  elementCardNumber.value!.focus();
});
</script>

<style scoped>
.ss-payment-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.ss-field {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.wrapper-buttons {
  display: flex;
  gap: 0.5rem;
}

.ss-card-element {
  border: 1px solid var(--border-default);
  border-radius: 8px;
  padding: 0.75rem 0 0.75rem 1rem;
}

.ss-card-element > #element-card-expiry,
.ss-card-element > #element-card-cvc {
  display: inline-block;
}

.ss-card-element:has(#element-card-expiry) {
  display: flex;
  gap: 0.5rem;
}

#element-card-expiry {
  flex: 1 1 40%;
  min-width: 0;
}

#element-card-cvc {
  flex: 1 1 60%;
  min-width: 0;
}

::v-deep(p) {
  line-height: 130%;
}
</style>
